import request from '../../request';
import { questionServiceAPI } from './insightsUrls';

export class questionService {
  static getQuestionsByTagId(id) {
    return request({
      url: questionServiceAPI.getQuestionsByTagId(id),
      method: 'GET',
    })
      .then((response) => response)
      .catch((response) => response);
  }

  static getAllQuestions() {
    return request({
      url: questionServiceAPI.getAll(),
      method: 'GET',
    })
      .then((response) => response)
      .catch((response) => response);
  }

  static delete(id) {
    return request({
      url: questionServiceAPI.delete(id),
      method: 'DELETE',
    })
      .then((response) => response)
      .catch((response) => response);
  }
  static post(data) {
    return request({
      url: questionServiceAPI.post(),
      method: 'POST',
      data,
    })
      .then((response) => response)
      .catch((response) => response);
  }
  static addUpdateQuestionForSuperAdmin(data) {
    return request({
      url: questionServiceAPI.addUpdateQuestionForSuperAdmin(),
      method: 'POST',
      data,
    })
      .then((response) => response)
      .catch((response) => response);
  }
}

export default questionService;
